import brand from "@/config/brand";

export const LogoMark = ({ size = 40 }) => (
  <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <rect width="40" height="40" rx="8" fill="#202020" />
    <path d="M12 28L18 14L22 22L26 14L30 28" stroke="#00AFA3" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="20" cy="10" r="2" fill="#E8C6A0" />
  </svg>
);

export const Logo = ({ dark = true, size = 36 }) => (
  <span className="flex items-center gap-3" data-testid="brand-logo">
    <LogoMark size={size} />
    <span
      className={`font-serif text-lg sm:text-xl font-medium tracking-tight whitespace-nowrap ${
        dark ? "text-cream" : "text-charcoal"
      }`}
    >
      {brand.name}
    </span>
  </span>
);

export default Logo;
